export default {
  backText: 'Use your card',
  heading: 'Start earning up to 6% cashback',
  description:
    'Get automatic cashback on everyday purchases online and in-store.',
  listItem1: 'Shop at over 10,000 brands nationwide',
  listItem2: 'Earn automatic cashback, just like that',
  disclosure: 'Disclosure',
  rewardsBtnText: 'See offers near me',
  titleMd: 'Control your card, secure your cash',
  cardDesc:
    'Freeze your card anytime and get purchase notifications instantly.',
  cardBtnText: 'View card',
  activateTitle: 'Turn spare change into savings',
  activateDesc:
    'Save Your Change rounds up every transaction to the nearest dollar and transfers the amount to your Savings Account.  Opt-out at any time.',
  activateBtnText: 'Activate Save Your Change',
  isCashBackText:
    'Cashback is available on specific items or services purchased with your Varo Debit Card or Varo Believe Card at select brands/retailers. Offer details may vary, see the Cashback tab for more details and current deals. The maximum Cashback that can be earned is seven-hundred and fifty dollars ($750 USD) per calendar month.',
};
